<template>
  <div id="operationsContainer" v-uploader="dropFileHandler">
    <div v-if="ifhuishou != '回收站'" class="left">
      <el-button v-if="addXtDesign && isShowAddFolder" size="small" type="primary" icon="el-icon-plus" @click="addFolder"> 新建文件夹 </el-button>
      <el-dropdown v-if="uploadXtDesign && isShowUploader && isMoveCopy" trigger="click" placement="bottom-start" @command="isFileOrFolder">
        <el-button size="small" type="primary" class="upload" plain icon="el-icon-upload2"> 上传 </el-button>
        <el-dropdown-menu slot="dropdown" style="width: 94px">
          <el-dropdown-item v-if="isShowUploader" command="file" style="text-align: center !important"> 文件 </el-dropdown-item>
          <!-- 上传文件夹同新建文件夹的权限 -->
          <el-dropdown-item v-if="isShowUploader" command="folder" style="text-align: center !important"> 文件夹 </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button v-if="downDesign && isDownFolder" size="small" type="primary" plain icon="el-icon-download" @click="batchDownload"> 下载 </el-button>
      <el-button v-if="shareXtDesign" size="small" type="primary" plain icon="el-icon-share" @click="batchShare"> 分享 </el-button>
      <el-button v-if="deleXtDesign && isDownFolder" size="small" type="danger" plain icon="el-icon-delete" @click="batchDel"> 删除 </el-button>
      <el-button v-if="isMoveCopy" size="small" type="primary" plain icon="el-icon-rank" @click="moveBtn"> 移动到 </el-button>
      <el-button v-if="isMoveCopy" size="small" type="primary" plain icon="el-icon-document-copy" @click="copyBtn"> 复制到 </el-button>
      <el-button v-if="selectArr && isShowAddModel && isRvtSkp" size="small" type="primary" @click="addModel"> 添加至整合模型 </el-button>
      <component :is="dynamicButtons"></component>
    </div>
    <div v-else>
      <el-button size="small" type="primary" :disabled="resumeShow" @click="thoroughDeleteOrRecover(2)"> 恢复 </el-button>
      <el-button v-if="deleCompletely" size="small" type="danger" @click="thoroughDeleteOrRecover(1)"> 彻底删除 </el-button>
    </div>
    <div class="search">
      <el-badge v-if="ifhuishou != '回收站'" :value="integrationValue" :hidden="integrationValue > 0 ? false : true">
        <el-button type="primary" size="small" @click="clickModel"> 待整合模型 </el-button>
      </el-badge>
      <el-button v-if="ifhuishou != '回收站'" class="rightBtn" type="primary" size="small" plain @click="openIntegrationRecord"> 整合记录 </el-button>
      <el-input
        v-model.trim="searchValue"
        :placeholder="searchTiTle"
        :suffix-icon="!searchValue ? 'el-icon-search' : ''"
        :clearable="Boolean(searchValue)"
        type="text"
        style="height: 100%; cursor: pointer"
        size="small"
        maxlength="20"
      >
      </el-input>
    </div>
    <moveCopy v-if="moveCopyShow" ref="moveCopy" :title="moveCopyTitle" @callback="refreshTable"></moveCopy>
    <IntegrationRecord ref="IntegrationRecord" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import docService from "@/CommonDP/service/doc-service";
import XtDesignService from "@/CommonDP/service/integratedModel-service";
import { downloadFile, downloadUrltoken } from "@/CommonDP/utils";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import IntegrationRecord from "./../fileTable/modelDialog/IntegrationRecord.vue";
import moveCopy from "@/CommonDP/components/documentRelevant/moveCopy.vue";
import empty from "@/CommonDP/components/empty";
import globalParams from "@/CommonDP/utils/globalParams";
import { uploader } from "@/CommonDP/utils/IUploader/dp";

export default {
  directives: { uploader: uploader.directive() },
  components: { moveCopy, IntegrationRecord, empty },
  data() {
    return {
      searchValue: "",

      integrationValue: "",
      moveCopyShow: false,
      dynamicButtons: "empty",
      specialFolderShowButtons: false,
      integrationValueShow: false,
      val: ""
    };
  },
  computed: {
    ...mapState({
      currentNode: (state) => state.XtDesign.currentTreeNode, // 左边点击的树
      prjInfo: (state) => state.projectMg.prjObj, // 项目
      selectArr: (state) => state.XtDesign.selectArr, // 勾选的文件
      integrationModel: (state) => state.XtDesign.integrationModel,
      userInfo: (state) => state.user.userInfo
    }),
    uploaderOpts() {
      const { folderId } = this.currentNode.data;
      const params = {
        prjId: this.prjInfo.prjId,
        folderId,
        versionId: ""
      };
      return { params, multiple: true, showPanel: true, once: false };
    },
    // 是否展示添加整合模型按钮
    isShowAddModel() {
      if (this.selectArr.length > 0) {
        // 如果第一次勾选的不是.rvt或者.skp，则不显示添加整合模型按钮
        const folderName = this.selectArr[0].folderName;
        const reg1 = /\.(rvt|skp|3dm|nwc|nwd|ifc|dgn|rvm|ipt|vue)$/;
        // 如果选中的模型存在不是.rvt或者.skp的格式，则不显示添加整合按钮
        const nameArr = [];
        this.selectArr.forEach((item) => {
          nameArr.push(item.folderName);
        });
        if (folderName.match(reg1)) {
          for (let i = 0; i < nameArr.length; i++) {
            const matches = nameArr[i].match(reg1);
            const name = matches && matches.length ? matches[0] : "";
            if (
              name !== ".rvt" &&
              name !== ".skp" &&
              name !== ".3dm" &&
              name !== ".nwc" &&
              name !== ".nwd" &&
              name !== ".ifc" &&
              name !== ".dgn" &&
              name !== ".rvm" &&
              name !== ".ipt" &&
              name !== ".vue"
            ) {
              return false;
            }
          }
          return true;
        }
      }
      return false;
    },
    isRvtSkp() {
      if (this.selectArr.length === 0) {
        return false;
      }
      // 如果第一次勾选的不是.rvt或者.skp，则不显示添加整合模型按钮
      const folderName = this.selectArr[0].folderName;
      const reg1 = /\.(rvt|skp|3dm|nwc|nwd|ifc|dgn|rvm|ipt|vue)$/;
      if (!folderName.match(reg1)) {
        return false;
      }
      // 如果选中的模型存在不是.rvt或者.skp的格式，则不显示添加整合按钮
      const nameArr = this.selectArr.map((item) => item.folderName);
      for (let i = 0; i < nameArr.length; i++) {
        const name = nameArr[i].match(reg1)[0];
        if (
          name !== ".rvt" &&
          name !== ".skp" &&
          name !== ".3dm" &&
          name !== ".nwc" &&
          name !== ".nwd" &&
          name !== ".ifc" &&
          name !== ".dgn" &&
          name !== ".rvm" &&
          name !== ".ipt" &&
          name !== ".vue"
        ) {
          return false;
        }
      }
      return true;
    },
    // 判断新建文件夹权限
    isShowAddFolder() {
      let { data } = this.currentNode;
      data = data || {};
      const isShow = data.folderType ? data.folderType !== 13 && data.folderType !== 16 && data.folderType !== 14 && data.folderType !== 18 : false;
      return data.folderNew === 1 && isShow;
    },
    // 判断上传文件的权限
    isShowUploader() {
      let { data } = this.currentNode;
      data = data || {};
      const isShow = data.folderType
        ? data.folderType !== 15 && data.folderType !== 13 && data.folderType !== 16 && data.folderType !== 19 && data.folderType !== 14 && data.folderType !== 18
        : false;
      return data.fileNew === 1 && isShow;
    },
    isDownFolder() {
      let { data } = this.currentNode;
      data = data || {};
      return data.folderType !== 14;
    },
    // 删除
    isDelete() {
      const array = this.selectArr.filter((item) => item.fileDel === 0);
      return array.length > 0;
    },
    searchTiTle() {
      let data = this.currentNode.data;
      data = data || {};
      const { folderName } = data;
      return folderName ? `搜索"${folderName}"` : "";
    },
    ifhuishou() {
      let data = this.currentNode.data;
      data = data || {};
      const { folderName } = data;
      return folderName;
    },
    // 提资区下不显示移动复制跟上传
    isMoveCopy() {
      let data = this.currentNode.data;
      data = data || {};
      const { folderArea, folderName, remark } = data;
      if (folderName === "提资区") return false;
      else if (folderArea === "2") return false;
      else if ((remark === "慧智目录" || remark === "理正目录") && this.specialFolderShowButtons) return false;
      else return true;
    },
    resumeShow() {
      // 如果勾选的文件里 有来自中心文件里的文件 就不让恢复
      const bool = this.selectArr.some((item) => {
        return item.folderType === 14;
      });
      return bool;
    },
    addXtDesign() {
      let data = this.currentNode.data;
      data = data || {};
      const { remark } = data;
      if ((remark === "慧智目录" || remark === "理正目录") && this.specialFolderShowButtons) {
        return false;
      } else {
        return checkPermission(this.$allPerms.XTDESIGN_ADD);
      }
    },
    uploadXtDesign() {
      let data = this.currentNode.data;
      data = data || {};
      const { remark } = data;
      if ((remark === "慧智目录" || remark === "理正目录") && this.specialFolderShowButtons) {
        return false;
      } else {
        return checkPermission(this.$allPerms.XTDESIGN_UPLOAD);
      }
    },
    downDesign() {
      return checkPermission(this.$allPerms.XTDESIGN_DOWN);
    },
    shareXtDesign() {
      let data = this.currentNode.data;
      data = data || {};
      const { remark } = data;
      if ((remark === "慧智目录" || remark === "理正目录") && this.specialFolderShowButtons) {
        return false;
      } else {
        return checkPermission(this.$allPerms.XTDESIGN_SHARE);
      }
    },
    deleXtDesign() {
      let data = this.currentNode.data;
      data = data || {};
      const { remark } = data;
      if ((remark === "慧智目录" || remark === "理正目录") && this.specialFolderShowButtons) {
        return false;
      } else {
        return checkPermission(this.$allPerms.XTDESIGN_DELE);
      }
    },
    deleCompletely() {
      return checkPermission(this.$allPerms.XTDESIGN_DELECOMPLETELY);
    }
  },
  watch: {
    searchValue(newValue, oldValue) {
      clearTimeout(this.timeID);
      if (newValue) {
        this.timeID = setTimeout(() => {
          console.log("开始搜索啦");
          this.search();
        }, 500);
      } else {
        this.refresh();
      }
    },
    prjInfo: {
      deep: true,
      handler: function ({ prjId }, oldValue) {
        if (prjId) {
          this.integrationModelNum();
        }
      }
    }
  },
  mounted() {
    // 等页面加载完毕，先调用一次获得smallValue的方法，使之显示应有的待整合模型
    // 之所以不调用this.addModel方法是因为会有弹出框的弹出
    const { prjId } = this.prjInfo;
    if (prjId) {
      this.integrationModelNum(2);
    }
    this.initDynamicButtons();
    this.manageButton();
  },
  methods: {
    refreshTable() {
      this.$emit("callback");
    },
    manageButton() {
      // 慧智 理正目录  需要隐藏掉 除了下载的按钮
      this.specialFolderShowButtons = globalParams.get("doc.operation.specialFolderShowButtons");
    },
    initDynamicButtons() {
      const com = globalParams.get("doc.operation.buttons");
      if (com) {
        this.dynamicButtons = com;
      }
    },
    // 判断是否有移动权限
    moveShow(row) {
      const down = this.downDesign && row.isRead === 2 && row.folderType !== 14;
      const isdelete = this.deleXtDesign && row.fileDel === 1 && row.folderType !== 14 && row.isSys === 0;
      return isdelete && down;
    },
    // 批量移动
    async moveBtn() {
      const { selectArr, moveShow } = this;
      if (selectArr.length === 0) return this.$message.warning("请选择文件");
      const move = selectArr.some((item) => moveShow(item) === false);
      if (move) {
        return this.$message.warning("您选择的文件中包含没有下载或删除权限的文件，无法移动，请重新选择");
      }
      this.moveCopyTitle = "移动到";
      this.moveCopyShow = true;
    },
    // 判断有下载权限
    downShow(row) {
      return this.downDesign && row.isRead === 2 && row.folderType !== 14;
    },
    copyBtn() {
      const { selectArr, downShow } = this;
      if (selectArr.length === 0) return this.$message.warning("请选择文件");
      const copy = selectArr.some((item) => downShow(item) === false);
      if (copy) {
        return this.$message.warning("您选择的文件中包含没有下载权限的文件，无法复制，请重新选择");
      }
      this.moveCopyTitle = "复制到";
      this.moveCopyShow = true;
    },
    batchShare() {
      const { selectArr } = this;
      const isRead = selectArr.some((item) => item.isRead === 0);
      if (selectArr.length === 0) return this.$message.warning("请选择文件");
      if (isRead) {
        return this.$message.warning("您选择的文件中包含没有分享权限的文件，请重新选择");
      }
      this.$store.dispatch("XtDesignIsShowShare");
    },
    async integrationModelNum() {
      if (!this.integrationValueShow) {
        this.integrationValueShow = true;
        const { prjId } = this.prjInfo;
        const res = await XtDesignService.getQueryList(prjId);
        this.integrationValue = res.data.length;
      }
    },
    async querySmallValue() {
      const { prjId: prjId } = this.prjInfo;
      const params = this.selectArr.map((item) => {
        return {
          fileId: item.folderId,
          fileName: item.folderName,
          fileVersion: item.fileVersion,
          prjId: prjId
        };
      });
      const res = await XtDesignService.integrationModel(params);
      if (res.result === "0") {
        XtDesignService.getQueryList(prjId)
          .then((res) => {
            if (res.result === "0") {
              this.integrationValue = res.data.length;
            }
          })
          .catch((e) => {
            this.$message.warning(e.message || "请求出错");
          });
      }
    },
    async ws() {
      const { prjId } = this.prjInfo;
      try {
        const res = await XtDesignService.getQueryList(prjId);
        this.integrationValue = res.data.length;
      } catch (error) {
        this.$message.warning(error || "请求出错");
      }
    },
    // 整合模型点击方法
    async clickModel() {
      const { prjId } = this.prjInfo;
      try {
        const res = await XtDesignService.getQueryList(prjId);
        this.$store.dispatch("XtDesignIsModelDialog");
        this.$store.dispatch("XtDesignModelDialogData", res.data);
      } catch (e) {
        this.$message.warning(e);
      }
    },
    // 添加至整合模型点击事件
    async addModel() {
      // 筛选满足的后缀文件
      const reg = /([^.]+)$/;
      const newArr = this.selectArr.map((item) => {
        return item.folderName.match(reg)[0];
      });
      var test = newArr.every((item) => {
        return (
          item === "skp" ||
          item === "rvt" ||
          item === "3dm" ||
          item === "nwc" ||
          item === "nwd" ||
          item === "ifc" ||
          item === "dgn" ||
          item === "rvm" ||
          item === "ipt" ||
          item === "vue"
        );
      });
      if (test === false) {
        this.$message({
          message: "现在仅支持rvt、skp、3dm、nwc、nwd、ifc、dgn、rvm、ipt和vue格式",
          type: "error"
        });
      } else {
        const jugStatus = this.selectArr.map((item) => {
          return item.status;
        });
        const result = jugStatus.every(function (item) {
          return item === "2" || item === "6";
        });
        if (result === false) {
          this.$message({ message: "存在轻量化未完成的文件", type: "error" });
        } else {
          this.$message({ message: "添加至整合模型成功", type: "success" });
          this.querySmallValue();
        }
      }
    },
    // 打开整合记录
    openIntegrationRecord() {
      this.$refs.IntegrationRecord.openDialog();
    },
    addFolder() {
      const { folderId } = this.currentNode.data;
      this.$prompt("", "新建文件夹", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入文件夹名称",
        inputPattern: /^\S*$/,
        inputErrorMessage: "文件夹名称不能包含空格",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        inputValidator: (value) => {
          if (!value) {
            return "文件夹名称不能为空";
          }
          if (value.length > 80) {
            return "文件夹名称不能大于80个字符";
          }
          var regExp = new RegExp('[\\\\|/:*<>?"]');
          if (regExp.test(value)) {
            return '文件夹名称不能包含以下字符:\\ / : * " ? < > |';
          }
          this.val = value;
        },
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            this.$store.dispatch("XtDesignUpdateMessageObj", {
              isShow: true,
              message: "新建中..."
            });
            const { prjId: prjId } = this.prjInfo;
            const parentId = folderId;
            const folderName = this.val.replace(/\s*/g, "");
            const data = { parentId, folderName, prjId };
            try {
              const result = await docService.queryAddFolder(data);
              if (result.result === "0") {
                await this.$store.dispatch("XtDesignUpdateNodeList", 'addFolder');
                this.$store.dispatch("XtDesignUpdateMessageObj", {
                  isShow: false
                });
                this.$message.success("新建成功");
                done();
              }
            } catch (e) {
              this.$store.dispatch("XtDesignUpdateMessageObj", { isShow: false });
            }
          } else {
            done();
          }
        }
      }).catch(() => {});
    },
    async dropFileHandler(files, cb) {
      const opts = this.uploaderOpts;
      if (this.uploadXtDesign && this.isShowUploader) {
        await cb(files, opts);
        this.refresh();
      }
    },
    async isFileOrFolder(type) {
      const opts = this.uploaderOpts;
      await uploader.open({ ...opts, isDirectory: type !== "file" });
      this.refresh();
    },
    async batchDel() {
      const { selectArr } = this;
      const fileIdsData = selectArr.filter((item) => item.isFolder === 0);
      const folderIdsData = selectArr.filter((item) => item.isFolder === 1);
      const fileDel = fileIdsData.some((item) => item.fileDel === 0);
      const folderDel = folderIdsData.some((item) => item.folderDel === 0);
      if (selectArr.length === 0) return this.$message.warning("请选择文件");
      if (fileDel || folderDel) {
        return this.$message.warning("您选择的文件中包含没有删除权限的文件，请重新选择");
      }
      const newData = selectArr.map((item) => item.folderId);
      const isdel = selectArr.filter((item) => item.isSys === 1);
      if (!isdel.length) {
        try {
          this.$confirm("确定删除吗?", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false
          })
            .then(async () => {
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: true,
                message: "删除中..."
              });
              const result = await docService.queryDeleteFile(newData);
              if (result.result === "0") {
                await this.$store.dispatch("XtDesignDelListRow", newData);
                this.$store.dispatch("XtDesignUpdateMessageObj", {
                  isShow: false,
                  message: ""
                });
                this.$message({ type: "success", message: "删除成功" });
                this.$emit("callback");
              }
            })
            .catch(() => {
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false,
                message: ""
              });
            });
        } catch (e) {
          this.$store.dispatch("XtDesignUpdateMessageObj", {
            isShow: false,
            message: ""
          });
        }
      } else {
        this.$message.warning("已选数据中包含系统文件夹,不能删除");
      }
    },

    batchDownload() {
      const { selectArr } = this;
      const isRead = selectArr.some((item) => item.isRead === 1 || item.isRead === 0);
      if (selectArr.length === 0) return this.$message.warning("请选择文件");
      if (isRead) {
        return this.$message.warning("您选择的文件中包含没有下载权限的文件，请重新选择");
      }
      const isFolder = selectArr.some((item) => item.isFolder === 1);
      if (isFolder) {
        return this.$message.warning("文件夹不支持批量下载");
      } else {
        const prjId = this.prjInfo.prjId;
        const urls = selectArr.map((item) => {
          return downloadUrltoken(prjId, item.folderId, item.fileVersion);
        });
        for (let i = 0; i < urls.length; i++) {
          downloadFile(urls[i]);
        }
      }
    },
    search() {
      const keyWord = this.searchValue.replace(/\s*/g, "");
      const name = this.searchValue.replace(/\s*/g, "");
      const { folderId } = this.currentNode.data;
      console.log(this.currentNode.data, "this.currentNode.data");
      const { prjId: prjId } = this.prjInfo;
      const searchObj = { prjId, folderId, keyWord };
      this.$store.dispatch("XtDesignUpdateMessageObj", {
        isShow: true,
        message: "搜索中..."
      });
      if (folderId === "recycle") {
        docService
          .queryRecycle(prjId, name)
          .then((res) => {
            if (res.result === "0") {
              this.$store.dispatch("XtDesignUpdateSearchStatus", true);
              for (var i = 0; i < res.data.length; i++) {
                this.$set(res.data[i], "isrecycle", true);
              }
              this.$store.dispatch("XtDesignUpdateList", res.data);
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false
              });
            }
          })
          .catch(() => {
            this.$store.dispatch("XtDesignUpdateMessageObj", { isShow: false });
          });
      } else {
        docService
          .querySearchFolder(searchObj)
          .then((res) => {
            if (res.result === "0") {
              this.$store.dispatch("XtDesignUpdateSearchStatus", true);
              for (var i = 0; i < res.data.length; i++) {
                this.$set(res.data[i], "isrecycle", false);
              }
              this.$store.dispatch("XtDesignUpdateList", res.data);
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false
              });
            }
          })
          .catch(() => {
            this.$store.dispatch("XtDesignUpdateMessageObj", { isShow: false });
          });
      }
    },
    refresh() {
      let { data } = this.currentNode;
      data = data || {};
      const { folderId } = data;
      if (folderId) {
        this.$store.dispatch("XtDesignUploadSucceedCB", folderId);
      }
    },
    async thoroughDeleteOrRecover(type) {
      if (this.selectArr.length === 0) {
        return this.$message.warning("请选择文件");
      }
      let messageType = "";
      type === 1 ? (messageType = "删除") : (messageType = "恢复");
      this.$store.dispatch("XtDesignUpdateMessageObj", {
        isShow: true,
        message: `${messageType}中...`
      });
      try {
        if (messageType === "删除") {
          this.$confirm("是否确定删除?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false
          })
            .then(async () => {
              const fileIdsData = this.selectArr.filter((item) => item.folderType !== 0);
              const folderIdsData = this.selectArr.filter((item) => item.folderType === 0);
              const fileIds = fileIdsData.map((item) => item.folderId);
              const folderIds = folderIdsData.map((item) => item.folderId);
              const Ids = fileIds.concat(folderIds);
              await docService.recycldelete({ fileIds, folderIds });
              await this.$store.dispatch("XtDesignDelListRow", Ids);
              this.$store.dispatch("XtDesignUpdateNodeList", "delete");
              this.$store.dispatch("XtDesignUpdateSelect", []);
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false,
                message: ""
              });
              this.$message.success(`${messageType}成功`);
            })
            .catch(() => {
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false,
                message: ""
              });
            });
        } else {
          // 恢复
          this.$confirm("进行批量恢复操作时候,若文件在原位置中已存在同名文件/文件夹,将对这类文件/文件夹进行跳过处理。", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false
          })
            .then(async () => {
              const fileIdsData = this.selectArr.filter((item) => item.folderType !== 0);
              const folderIdsData = this.selectArr.filter((item) => item.folderType === 0);
              const fileIds = fileIdsData.map((item) => item.folderId);
              const folderIds = folderIdsData.map((item) => item.folderId);
              await docService.recyclerestore({ fileIds, folderIds, isBatch: 1 });
              this.$store.dispatch("XtDesignUpdateNodeList", "recover");
              this.$store.dispatch("XtDesignUpdateSelect", []);
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false,
                message: ""
              });
              this.$message.success(`${messageType}成功`);
            })
            .catch(() => {
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false,
                message: ""
              });
            });
        }
      } catch (e) {
        this.$store.dispatch("XtDesignUpdateMessageObj", {
          isShow: false,
          message: ""
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#operationsContainer {
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--small-space) var(--big-space);
  box-sizing: border-box;
  border-bottom: 1px solid #e5e8f1;

  .el-dropdown {
    margin-right: var(--small-space);
    margin-left: var(--small-space);
  }

  .left {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    > .el-button {
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .upload {
      margin-top: 5px;
      margin-bottom: 5px;
    }
  }

  .search {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    /deep/.el-button,
    .el-input {
      margin-bottom: 5px;
      margin-top: 5px;
    }

    .rightBtn {
      margin-left: 15px;
      margin-right: 15px;
    }
  }
}

.el-badge__content /deep/ .is-fixed {
  top: 0;
}
</style>
